import { DemoAlarmIngestForm } from '@hakimo-ui/hakimo/feature-demo-alarm-ingest';
import { UserProfileRoot } from '@hakimo-ui/hakimo/feature-user-profile';
import { useIsDemoSupportRole } from '@hakimo-ui/hakimo/util';
import { TabItem } from '@hakimo-ui/shared/ui-base';
import { Route } from 'react-router-dom';

const DEMO_ALARM_INGEST_TABS: TabItem<string>[] = [
  { id: 'demo-alarm-ingest', name: 'Ingest demo alarms' },
];
const NO_EXTRA_TABS: TabItem<string>[] = [];
const DEMO_ALARM_INGEST_ROUTES = (
  <Route path="demo-alarm-ingest" element={<DemoAlarmIngestForm />} />
);

export function ProfileRoute() {
  const canSeeIngest = useIsDemoSupportRole();
  return (
    <UserProfileRoot
      extraTabs={canSeeIngest ? DEMO_ALARM_INGEST_TABS : NO_EXTRA_TABS}
      extraRoutes={canSeeIngest ? DEMO_ALARM_INGEST_ROUTES : undefined}
    />
  );
}
